import { END_POINT } from "../../constants/api.constants";
import { store } from "../../store";
// import { resetUserTokenAction } from "../../reducers/app.reducer";

const {
  CATEGORY_LIST,
  PRODUCTS_LIST,
  INVENTORY_ITEMS_LIST,
  INVENTORY_SEARCH,
  INVENTORY_CATEGORY,
  INVENTORY_FILTER,
  INVENTORY_FILTER_COUNT,
  INVENTORY_FILTER_RESULT,
  INVENTORY_BOM_UPLOAD,
  INVENTORY_BOM_COLUMN_MAPPING,
  INVENTORY_BOM_DETAIL,
  INVENTORY_EDIT_PART_NUMBER,
  INVENTORY_BOM_COLUMN_KEY_SAVE,
  INVENTORY_BOM_QUOTE_GENERATE,
  INVENTORY_BOM_STATUS,
  BOM_ITEM_REFRESH,
  NEWS_LETTER_CREATE,
  PRODUCTS_ACTIVE_PRODUCT,
  PRODUCTS_PRODUCT_BY_SLUG,
} = END_POINT;

// export const getManufacturesDataApi = async () => {
//   return await fetch(MANUFACTURES_LIST, {
//     method: "GET",
//     headers: {
//       "content-type": "application/json",
//     },
//   })
//     .then((res) => res.json())
//     .then((response) => {
//       // console.log(response.data);
//       if (response.status)
//         return {
//           status: true,
//           data: response.data,
//         };
//       else {
//         return { status: false, message: response.message };
//       }
//     })
//     .catch(function (error) {
//       return {
//         status: false,
//         message: "Something went wrong, please try again later.",
//         error,
//       };
//     });
// };

export const getCategoryDataApi = async () => {
  return await fetch(CATEGORY_LIST, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getProductDataAPI = async () => {
  return await fetch(PRODUCTS_LIST, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getActiveProductDataAPI = async () => {
  return await fetch(PRODUCTS_ACTIVE_PRODUCT, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getProductBySlugAPI = async (slug) => {
  return await fetch(`${PRODUCTS_PRODUCT_BY_SLUG}/${slug}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch((error) => {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getInventoryItemsDataApi = async () => {
  return await fetch(INVENTORY_ITEMS_LIST, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getInventorySmartFilterCountAPI = async (payload) => {
  return await fetch(INVENTORY_FILTER_COUNT, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getInventorySearchAPI = async (payload, filters) => {
  // console.log({ token: store.getState().app.token });
  return await fetch(`${INVENTORY_SEARCH}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getInventoryCategoryAPI = async (payload) => {
  console.log({ token: store.getState().app.token });
  return await fetch(INVENTORY_CATEGORY, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    // body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getInventoryFilterAPI = async (activeCategory) => {
  // console.log({ token: store.getState().app.token });
  return await fetch(INVENTORY_FILTER + "?uniqueId=" + activeCategory, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      // token: store.getState().app.token,
    },
    // body: JSON.stringify(activeCategory),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getFilterResultAPI = async (payload) => {
  console.log({ token: store.getState().app.token });
  return await fetch(INVENTORY_FILTER_RESULT, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const uploadBomFileAPI = async (file) => {
  // console.log({ file });
  const formData = new FormData();
  formData.append("file", file[0]);
  return await fetch(INVENTORY_BOM_UPLOAD, {
    method: "POST",
    headers: {
      token: store.getState().app.token,
    },
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: { file: data.file, extension: data.extension, bom: data.bom },
          message: data.message,
        };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const bomColumnKeySaveAPI = async (payload) => {
  return await fetch(INVENTORY_BOM_COLUMN_KEY_SAVE, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return { status: true, data: data.data, message: data.message };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const columnMappingAPI = async (id) => {
  return await fetch(INVENTORY_BOM_COLUMN_MAPPING + id, {
    method: "GET",
    headers: {},
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return { status: true, data: data.data, message: data.message };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const editPartNumberAPI = async (id, payload) => {
  console.log(INVENTORY_EDIT_PART_NUMBER + id);

  return await fetch(INVENTORY_EDIT_PART_NUMBER + id, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        return { status: true, data: data.data, message: data.message };
      }
      return { status: false, message: data.message };
    })
    .catch((error) => ({
      status: false,
      message: "Something went wrong",
      error,
    }));
};


export const bomDetailAPI = async (id) => {
  return await fetch(INVENTORY_BOM_DETAIL + id, {
    method: "GET",
    headers: {},
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return { status: true, data: data.data, message: data.message };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomStatusAPI = async (id) => {
  return await fetch(INVENTORY_BOM_STATUS, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ uniqueId: id }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: {
            bom: data.bom,
            bom_items: data.bom_items,
            distributorMin: data.DistributorMinimumPrice,
          },
          message: data.message,
        };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomItemRefreshAPI = async (id) => {
  return await fetch(BOM_ITEM_REFRESH, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: data.data,
          message: data.message,
        };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const createQuoteAPI = async (tableData) => {
  if (!tableData || tableData.length === 0) {
    console.error("tableData is empty!");
    return { status: false, message: "No BOM data to export" };
  }

  return await fetch(INVENTORY_BOM_QUOTE_GENERATE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      bomData: tableData, // sending processed table data
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        return {
          status: true,
          filePath: data.filePath,
          fileName: data.fileName,
        };
      } else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const createNewsLetterAPI = async (payload) => {
  return await fetch(NEWS_LETTER_CREATE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data };
      else {
        // checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

// export const checkForExpiredToken = (message) => {
//   if (message === "Token expired" || message === "Invalid token") {
//     store.dispatch(resetUserTokenAction());
//     return;
//   }

//   if (message === "Token refresh") window.location = "/refresh-password";
// };
